import { Link, useLocation, useNavigate } from "react-router-dom";
import "./topbar.css";
import logo from "../../assets/images/logo.jpg";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function TopBar() {
	const [blogDropdownOpen, setBlogDropdownOpen] = useState(false);
	const [therapyDropdownOpen, setTherapyDropdownOpen] = useState(false);
	const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
	const [hamburgerOpen, setHamburgerOpen] = useState(false);
	const blogDropdownRef = useRef(null);
	const therapyDropdownRef = useRef(null);
	const servicesDropdownRef = useRef(null);
	const hamburgerRef = useRef(null);
	const { t, i18n } = useTranslation();
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	const toggleBlogDropdown = () => {
		setBlogDropdownOpen(!blogDropdownOpen);
	};

	const toggleTherapyDropdown = () => {
		setTherapyDropdownOpen(!therapyDropdownOpen);
	};

	const toggleServicesDropdown = () => {
		setServicesDropdownOpen(!servicesDropdownOpen);
	};

	const toggleHamburger = () => {
		setHamburgerOpen(!hamburgerOpen);
	};

	const handleClickOutside = (event) => {
		if (
			blogDropdownRef.current &&
			!blogDropdownRef.current.contains(event.target)
		) {
			setBlogDropdownOpen(false);
		}
		if (hamburgerRef.current && !hamburgerRef.current.contains(event.target)) {
			setHamburgerOpen(false);
		}
		if (
			servicesDropdownRef.current &&
			!servicesDropdownRef.current.contains(event.target)
		) {
			setServicesDropdownOpen(false);
		}
		if (
			therapyDropdownRef.current &&
			!therapyDropdownRef.current.contains(event.target)
		) {
			setTherapyDropdownOpen(false);
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, []);

	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 50);
		};

		document.addEventListener("scroll", handleScroll);

		return () => {
			document.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleLinkClick = (to) => (event) => {
		event.preventDefault();

		if (to === pathname) {
			window.scrollTo(0, 0);
		} else {
			navigate(to);
		}
	};

	return (
		<>
			<div className="top">
				<div className="infoContainer">
					<div className="infoWrapper">
						<i className="contactIcon fa-solid fa-phone">
							<a href="tel:088 550 6682">+359 885 506 682</a>
						</i>
						<i className="contactIcon fa-solid fa-envelope">
							<a href="mailto:stanislava_mitova@yahoo.com">
								stanislava_mitova@yahoo.com
							</a>
						</i>
					</div>
				</div>
				<div className="topNav">
					<div className={`topLeft ${scrolled ? "scrolledTopLeft" : ""}`}>
						<Link
							className="link excludeHover"
							to="/"
							onClick={handleLinkClick("/")}
						>
							<img className="topImg" src={logo} alt="logo" />
						</Link>
						<span className="person">{t("topbar.name")}</span>
						{/* <span className="person">Станислава Митова</span> */}
						<span className="profession">{t("topbar.profession")}</span>
					</div>
					<div className="topCenter">
						<div className="hamburgerMenu">
							<i
								ref={hamburgerRef}
								onClick={toggleHamburger}
								className="fa fa-bars"
								aria-hidden="true"
							></i>
							{hamburgerOpen && (
								<ul className="hamburgerList">
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/"
											onClick={handleLinkClick("/")}
										>
											{t("topbar.nav.home")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/about"
											onClick={handleLinkClick("/about")}
										>
											{t("topbar.nav.about")}
											{/* ЗА МЕН */}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										{t("topbar.nav.services")}
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/personal-coaching-therapy"
											onClick={handleLinkClick("/personal-coaching-therapy")}
										>
											{t("topbar.services_list.individual")}
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/energy-coaching"
											onClick={handleLinkClick("/energy-coaching")}
										>
											{t("topbar.services_list.energy")}
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/leadership-coaching"
											onClick={handleLinkClick("/leadership-coaching")}
										>
											{t("topbar.services_list.leadership")}
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/reiki"
											onClick={handleLinkClick("/reiki")}
										>
											{/* Рейки */}
											{t("topbar.services_list.reiki")}
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/soul-detective"
											onClick={handleLinkClick("/soul-detective")}
										>
											Soul Detective
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/inner-child-healing"
											onClick={handleLinkClick("/inner-child-healing")}
										>
											{t("topbar.services_list.inner_child")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/programs"
											onClick={handleLinkClick("/programs")}
										>
											{t("topbar.nav.programs")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/events"
											onClick={handleLinkClick("/events")}
										>
											{t("topbar.nav.events")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/gallery"
											onClick={handleLinkClick("/gallery")}
										>
											{t("topbar.nav.gallery")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/prices"
											onClick={handleLinkClick("/prices")}
										>
											{t("topbar.nav.prices")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										{t("topbar.nav.blog")}
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/forbes-interview"
											onClick={handleLinkClick("/forbes-interview")}
										>
											Forbes
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/my-path"
											onClick={handleLinkClick("/my-path")}
										>
											{t("topbar.blog_list.path")}
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/my-femine-path"
											onClick={handleLinkClick("/my-femine-path")}
										>
											{t("topbar.blog_list.feminine")}
										</Link>
									</li>
									<li className="hamburgerMenuItem">
										<Link
											className="link"
											to="/mother-father-son"
											onClick={handleLinkClick("/mother-father-son")}
										>
											{t("topbar.blog_list.family")}
										</Link>
									</li>
									<li className="hamburgerMenuItemSectionName">
										<Link
											className="link"
											to="/soul-club"
											onClick={handleLinkClick("/soul-club")}
										>
											{t("topbar.nav.soul_club")}
										</Link>
									</li>
								</ul>
							)}
						</div>
						<ul className="topList ">
							<li className="topListItem">
								<Link className="link" to="/" onClick={handleLinkClick("/")}>
									{t("topbar.nav.home")}
								</Link>
							</li>
							<li className="topListItem">
								<Link
									className="link"
									to="/about"
									onClick={handleLinkClick("/about")}
								>
									{t("topbar.nav.about")}
								</Link>
							</li>
							<li
								className="topListItem dropdown"
								onClick={toggleServicesDropdown}
								ref={servicesDropdownRef}
							>
								<span>{t("topbar.nav.services")}</span>
								<i
									className={`dropdownIcon ${
										servicesDropdownOpen ? "rotate180" : ""
									} fa-solid fa-caret-down`}
								></i>
								<ul
									className={`dropdownMenu ${
										servicesDropdownOpen ? "visible" : ""
									}`}
								>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/personal-coaching-therapy"
											onClick={handleLinkClick("/personal-coaching-therapy")}
										>
											{t("topbar.services_list.individual")}
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/energy-coaching"
											onClick={handleLinkClick("/energy-coaching")}
										>
											{t("topbar.services_list.energy")}
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/leadership-coaching"
											onClick={handleLinkClick("/leadership-coaching")}
										>
											{t("topbar.services_list.leadership")}
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/reiki"
											onClick={handleLinkClick("/reiki")}
										>
											{t("topbar.services_list.reiki")}
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/soul-detective"
											onClick={handleLinkClick("/soul-detective")}
										>
											Soul Detective
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/inner-child-healing"
											onClick={handleLinkClick("/inner-child-healing")}
										>
											{t("topbar.services_list.inner_child")}
										</Link>
									</li>
								</ul>
							</li>
							<li className="topListItem">
								<Link
									className="link"
									to="/programs"
									onClick={handleLinkClick("/programs")}
								>
									<span>{t("topbar.nav.programs")}</span>
								</Link>
							</li>
							<li className="topListItem">
								<Link
									className="link"
									to="/events"
									onClick={handleLinkClick("/events")}
								>
									<span>{t("topbar.nav.events")}</span>
								</Link>
							</li>
							<li className="topListItem">
								<Link
									className="link"
									to="/gallery"
									onClick={handleLinkClick("/gallery")}
								>
									<span>{t("topbar.nav.gallery")}</span>
								</Link>
							</li>
							<li className="topListItem">
								<Link
									className="link"
									to="/prices"
									onClick={handleLinkClick("/prices")}
								>
									<span>{t("topbar.nav.prices")}</span>
								</Link>
							</li>
							<li
								className="topListItem dropdown"
								onClick={toggleBlogDropdown}
								ref={blogDropdownRef}
							>
								<span>{t("topbar.nav.blog")}</span>
								<i
									className={`dropdownIcon ${
										blogDropdownOpen ? "rotate180" : ""
									} fa-solid fa-caret-down`}
								></i>
								<ul
									className={`dropdownMenu ${
										blogDropdownOpen ? "visible" : ""
									}`}
								>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/forbes-interview"
											onClick={handleLinkClick("/forbes-interview")}
										>
											Forbes
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/my-path"
											onClick={handleLinkClick("/my-path")}
										>
											{t("topbar.blog_list.path")}
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/my-femine-path"
											onClick={handleLinkClick("/my-femine-path")}
										>
											{t("topbar.blog_list.feminine")}
										</Link>
									</li>
									<li className="dropdownMenuItem">
										<Link
											className="link"
											to="/mother-father-son"
											onClick={handleLinkClick("/mother-father-son")}
										>
											{t("topbar.blog_list.family")}
										</Link>
									</li>
								</ul>
							</li>
								<li className="topListItem">
									<Link
										className="link"
										to="/soul-club"
										onClick={handleLinkClick("/soul-club")}
									>
										<span>{t("topbar.nav.soul_club")}</span>
									</Link>
								</li>
						</ul>
					</div>
					<div className="topRight">
						<a
							href="https://www.facebook.com/soulmindhealth"
							target="_blank"
							rel="noreferrer"
						>
							<i className="topIcon fa-brands fa-square-facebook"></i>
						</a>
						<a
							href="https://www.instagram.com/stanislava_mitova_/"
							target="_blank"
							rel="noreferrer"
						>
							<i className="topIcon fa-brands fa-instagram"></i>
						</a>
						<div className="langSwitcher">
							<div
								className={`langItem ${i18n.language === "bg" ? "activeLang" : ""}`}
								onClick={() => changeLanguage("bg")}
							>
								<img
									src="https://flagcdn.com/w40/bg.png"
									srcSet="https://flagcdn.com/w80/bg.png 2x"
									width="24"
									height="18"
									alt="Bulgaria"
									className="flagIcon"
								/>
								{/* <span className="langText">BG</span> */}
							</div>

							<div
								className={`langItem ${i18n.language === "en" ? "activeLang" : ""}`}
								onClick={() => changeLanguage("en")}
							>
								<img
									src="https://flagcdn.com/w40/gb.png"
									srcSet="https://flagcdn.com/w80/gb.png 2x"
									width="24"
									height="18"
									alt="United Kingdom"
									className="flagIcon"
								/>
								{/* <span className="langText">EN</span> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
